define([
    'edge/platform/base/BaseCtrl',
    'edge/platform/flow/modelhelpers/SnapshotBuilder',
    'underscore',
], (BaseCtrl, snapshotBuilder, _) => {

    fn.$inject = ['BaslerCommonService', '$scope', '$filter', 'MFPService', 'MFPCoverageService', 'BASLER_QUESTIONSET_CONFIG', 'submissionViewModel', 'StateUtils', '$timeout', 'ContextService', 'MFP_VEHICLE_CONSTANTS', 'LocaleService', 'LoggingService', 'BaslerLoggingConstants', 'qnb.CustomQuoteService', 'GoogleTagManagerService', 'BaslerQuestionSetService', 'QuestionSetService'];

    function fn(BaslerCommonService, $scope, $filter, MFPService, MFPCoverageService, BASLER_QUESTIONSET_CONFIG, submissionViewModel, StateUtils, $timeout, ContextService, MFP_VEHICLE_CONSTANTS, LocaleService, LoggingService, BaslerLoggingConstants, CustomQuoteService, GoogleTagManagerService, BaslerQuestionSetService, QuestionSetService) { // NOSONAR

        const ctrl = Object.create(BaseCtrl);

        function initView() {
            $scope.hasVariousDrivers = MFPService.hasVariousDrivers($scope.quoteandbind.submission.draftData);
            StateUtils.activeDataForState(true).flowModel.snapshot = snapshotBuilder($scope.quoteandbind.submissionView);

            $scope.draftDataView = $scope.quoteandbind.submissionView.draftData;
            $scope.quoteandbind.submission.bindData.language = LocaleService.getCurrentLocale();
            $scope.licensePlateNrView = $scope.quoteandbind.submissionView.draftData.lobs.mFPLine.licensePlateNumber;

            $scope.accountHolderAsView = $scope.draftDataView.accountHolder.contact;
            $scope.accountHolder = $scope.accountHolderAsView.value;

            // setting language
            $scope.accountHolderAsView.primaryLanguage.value = BaslerCommonService.setOrResetDocumentLanguage($scope.accountHolderAsView.primaryLanguage.value);
            const mainDriver = $scope.quoteandbind.submission.draftData.lobs.mFPLine.drivers[0];
            if (!mainDriver && !$scope.hasVariousDrivers) {
                console.error('Main Driver not found in $scope.quoteandbind.submissionView.draftData.lobs.mFPLine.drivers[0]');
                //throw exception;
            }

            // For a person, if the main driver exist and is not the account holder, retrieve their View object, fo company always retrieve main driver
            if ($scope.accountHolder.isCompany || !MFPService.accountHolderIsMainDriver($scope.draftDataView.value)) {
                if (!$scope.hasVariousDrivers) {
                    $scope.mainDriverAsView = $scope.draftDataView.lobs.mFPLine.drivers.findFirstElement(mainDriver).person;
                }
            }

            //main vehicle with context binding=true
            $scope.mainVehicleView = MFPService.getVehicle($scope.quoteandbind.submissionView.draftData.lobs.mFPLine.vehicles, MFP_VEHICLE_CONSTANTS.MAIN_VEHICLE_NUMBER);
            $scope.mainVehicleName = $scope.mainVehicleView.value.displayName;

            if (!$scope.mainVehicleView.matriculationInformation || !$scope.mainVehicleView.matriculationInformation.matriculationNumber) {
                $scope.mainVehicleView.matriculationInformation = MFPService.initMatriculationInformation();
            }

            if (ContextService.isPartnerLeasingProduct()) {
                $scope.mainVehicleView.value.additionalInterest = {leaseContractNumber: undefined};
            }

            // Checking if there is a second vehicle
            if ($scope.quoteandbind.submission.draftData.lobs.mFPLine.vehicles.length > 1) {
                $scope.additionalVehicleView = MFPService.getVehicle($scope.quoteandbind.submissionView.draftData.lobs.mFPLine.vehicles, MFP_VEHICLE_CONSTANTS.ADDITIONAL_VEHICLE_NUMBER);
                $scope.additionalVehicleName = $scope.additionalVehicleView.value.displayName;

                if (!$scope.additionalVehicleView.matriculationInformation || !$scope.additionalVehicleView.matriculationInformation.matriculationNumber) {
                    $scope.additionalVehicleView.matriculationInformation = MFPService.initMatriculationInformation();
                }
            }

            const quoting = $scope.quoteandbind.submission.quoteData;
            $scope.selectedQuote = _.findWhere(quoting.offeredQuotes, {isSelected: true});
            const terms = MFPService.getTermsWhichIncludeTerm($scope.selectedQuote, "MFPPartialComprehensiveFreeGarageChoice");
            $scope.freeGarageTerms = terms.filter(t => t.patternCode === 'MFPPartialComprehensiveFreeGarageChoice');
            if ($scope.freeGarageTerms.length > 0) {
                $scope.term = $scope.freeGarageTerms[0];
            }
            $scope.coverageGroups = MFPCoverageService.getCoveragesGroupedForDisplay($scope.selectedQuote.lobs.mFPLine, ['mFPLine', 'all']);
            $scope.getPromotionDataFromSelectedQuote = (selectedQuote) => {
                $scope.promotionData = MFPCoverageService.getGroupedPromotionsForDisplay(selectedQuote.lobs.mFPLine);
                $scope.promotionSum = MFPCoverageService.getPromotionSumFromGroupedPromotions($scope.promotionData);
            };
            $scope.getPromotionDataFromSelectedQuote($scope.selectedQuote);


            $scope.periodStart = $scope.draftDataView.periodStartDate;
            $scope.periodEnd = $scope.draftDataView.periodEndDate;
            $scope.paymentMethod = $scope.draftDataView.paymentMethod;
            $scope.premiumAmount = $scope.selectedQuote.total;
            $scope.originalTotal = $scope.selectedQuote.originalTotal;
            $scope.monthlyAmount = $scope.selectedQuote.monthlyPremium;

            //question sets
            $scope.questionSets = QuestionSetService.getQuestionSetViewModel($scope.quoteandbind.submission.draftData.lobs.mFPLine.preQualQuestionSets);
            BaslerQuestionSetService.createQuestionSetViewModelAddons(
                BASLER_QUESTIONSET_CONFIG.createConfirmationConfig($scope.quoteandbind.submission, ContextService),
                $scope.questionSets
            );

            const generalQuestionSet = $scope.questionSets.find(qs => qs.value.code === 'BSLgeneralUWQuestions');
            if (!generalQuestionSet) {
                throw new Error('BSLgeneralUWQuestions not found. This error is unexpected. Usually this happens when PolicyCenter returns the wrong or no questionSets')
            }
            if (generalQuestionSet.questions.length === 0) {
                throw new Error('No Questions inside BSLgeneralUWQuestions Questionset available.');
            }
            $scope.firstConfirmationQuestion = generalQuestionSet.questions[0];
            $scope.firstConfirmationQuestion.value = false;

            $scope.$watch('firstConfirmationQuestion.value', (newValue, oldValue) => {
                /*
                    The first confirmation question is getting used to tick all the questions bc there is a viewmodel needed for the checkbox
                * */
                if (newValue !== oldValue) {
                    $scope.questionSets.forEach((questSet) => {
                        questSet.questions.forEach((quest) => {
                            if (quest.aspects.baslerAvailable && quest.aspects.visible) {
                                quest.answer = newValue === true ? 'true' : null;
                            }
                        });
                    });
                }
            });
            // quoteId and sessionId for the button set
            $scope.quoteId = $scope.quoteandbind.submission.quoteID;
            $scope.sessionId = $scope.quoteandbind.submission.sessionUUID;
            $scope.languageSelectionOptions = BaslerCommonService.getDocumentLanguages();

            $scope.showFreeGarageSelection = MFPService.showFreeGarageSelection($scope.selectedQuote);
            const vehicleDisplayKey =
                $scope.quoteandbind.submission.draftData.lobs.mFPLine.vehicles.length > 1 ?
                    'quoteandbind.views.mfp-summary.insured.vehicles' :
                    'quoteandbind.views.mfp-summary.insured.vehicle';
            $scope[vehicleDisplayKey] = $filter('translate')('vehiclesHeadingLabel');

            initProofOfInsuranceQuestions();
            $scope.$watch('licensePlateNrView.value', initProofOfInsuranceQuestions);

            function initProofOfInsuranceQuestions() {
                $scope.quoteandbind.submissionView.bindData.proofOfInsuranceQuestions = MFPService.initProofOfInsuranceQuestions($scope.quoteandbind.submission.draftData.lobs.mFPLine.licensePlateNumber);
                if (_.isObject($scope.quoteandbind.submission.bindData.proofOfInsuranceQuestions)) {
                    $scope.quoteandbind.submissionView.bindData.proofOfInsuranceQuestions.isMultivehicle.value = ($scope.quoteandbind.submission.draftData.lobs.mFPLine.vehicles.length > 1);
                    $scope.proofOfInsuranceQuestionsView = $scope.quoteandbind.submissionView.bindData.proofOfInsuranceQuestions;
                }
            }
        }

        ctrl.init = function () {
            const submissionVm = submissionViewModel();
            const submission = submissionVm.value;
            $scope.quoteandbind = {
                submission: submission,
                submissionView: submissionVm,
            };

            $scope.termValueChanged = () => {
                function updateSecondVehicleIfAvailable() {
                    if ($scope.freeGarageTerms.length > 1) {
                        $scope.freeGarageTerms[1].chosenTerm = $scope.term.chosenTerm;
                        $scope.freeGarageTerms[1].updated = true; // this is needed from the backend, otherwise the coverage term does not get updated properly
                    }
                }

                $scope.term.updated = true; // this is needed from the backend, otherwise the coverage term does not get updated properly
                updateSecondVehicleIfAvailable();
                const sessionUUID = $scope.quoteandbind.submission.sessionUUID;
                const quoteId = $scope.quoteandbind.submission.quoteID;
                /*
                    callgroups value `inpage_quoteandbind` is used to automatically display loading spinner during call
                * */
                if ($scope.selectedQuote) {
                    CustomQuoteService.updateCustomQuote('inpage_quoteandbind', $scope.selectedQuote, sessionUUID, quoteId).then((response) => {
                        const quoting = $scope.quoteandbind.submission.quoteData;
                        $scope.selectedQuote = _.findWhere(quoting.offeredQuotes, {isSelected: true});
                        MFPService.updateOffering($scope.selectedQuote, response);
                        initView();
                        $scope.termChanged = true;
                    });

                }
            }

            initView();
        };


        ctrl.showLeasingInfo = ContextService.isPartnerLeasingProduct;

        ctrl.showLanguageSelection = function () {
            return (BaslerCommonService.isEnglishman(LocaleService.getCurrentLocale()) ||
                $scope.accountHolderAsView.primaryLanguage.value === null);
        };

        ctrl.isNationalityLichtenstein = function () {
            return $scope.draftDataView.accountHolder.contact.primaryAddress.state.value.code === 'CH_FL';
        };

        ctrl.isCompany = function () {
            return $scope.accountHolder.isCompany;
        };

        // Save the submission, quote it and forward to the quoting page
        ctrl.setNextState = function (form) {
            form.submitted = true;
            if (!form.valid) {

                //Scroll to first field with error
                const scroll = function () {
                    if ($('.gw-error-inline').length > 0) {
                        $('html, body').animate({scrollTop: $('.gw-error-inline').offset().top - 60}, 1000);
                    }
                };
                $timeout(scroll);

                //stay on current page
                return;
            }

            LoggingService.logInfo(BaslerLoggingConstants.CHANGEPAGE);

            const {flowModel} = StateUtils.activeDataForState(true);
            $scope.quoteandbind.submission.draftData.dataProcessingConfirmed = true;

            const price = $scope.originalTotal.amount;
            const isCompany = $scope.accountHolder.isCompany;

            GoogleTagManagerService.pushPurchaseDataToDataLayer(price, isCompany);

            return flowModel.next($scope.quoteandbind.submissionView);
        };

        ctrl.goToPrevious = function () {
            StateUtils.activeDataForState(true).flowModel.previous($scope.quoteandbind.submissionView);
        };

        ctrl.getVehicleImage = function () {
            const imageName = ContextService.isMotorcycleMode() ? 'motorcycle.svg' : 'briefcase.svg';
            return `/qnb/styles/images/common/${imageName}`;
        };

        ctrl.getContractConditionsDocURL = function () {
            return MFPService.getContractConditionsDocURL($scope.quoteandbind.submissionView.value);
        };

        ctrl.getContractConditionsLichtensteinDocURL = function () {
            return MFPService.getContractConditionsLichtensteinDocURL($scope.quoteandbind.submissionView.value);
        };

        /*
         * Function to display UWIssues that shall not redirect to contact us page.
         * Watch changes in submissionViewModel(), that it's modified by Flow API
         */
        $scope.$watch(() => {
            return submissionViewModel();
        }, () => {
            $scope.uwPromise = MFPService.showUWPopupIfNeeded(submissionViewModel(), $scope.uwPromise);

            if ($scope.uwPromise) {
                $scope.uwPromise.then(() => {
                    $scope.uwPromise = undefined; //allow display one popup at the time
                    submissionViewModel().uWIssues.value = undefined; //remove UW issues after confirmation and allow move forward
                });
            }
        });

        return ctrl.create($scope);
    }

    return fn;
});



// WEBPACK FOOTER //
// ../common/js/src/edge/quoteandbind/mfp/controllers/MFPSummaryCtrl.js